<template>
  <div>
    <br />
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="alert.message = ''"
      ></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
      ><br />
      {{ alert.reason }}
    </div>
    <div class v-if="data.data && data.data.length > 0">
      <a href data-toggle="modal" @click="download()">
        <button class="btn btn-outline-brand m-btn m-btn--outline">
          <i class="fas fa-download"></i> Baixar
        </button>
      </a>
    </div>

    <div class="row mt-3">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">Filtros extras</div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <label>Grupo</label>
                <SelectCustomerGroups
                  :selected="filters.groupId"
                  @change="setFilter('groupId', $event)"
                  class="form-control-sm"
                  name="selectReport"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div class="table-responsive">
              <div class="container-table">
                <table
                  class="table table-striped- table-bordered table-hover table-checkable"
                >
                  <caption></caption>
                  <thead>
                    <tr>
                      <th
                        id="customer_id"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle pointer"
                        :class="{ 'table-sorted': sortType == 'customer_id' }"
                        @click="sortCall('customer_id')"
                      >
                        ID Cliente
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'customer_id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'customer_id' && sortReverse"
                        ></span>
                        <span
                          class="fal fa-sort sort"
                          v-if="sortType != 'customer_id'"
                        ></span>
                      </th>
                      <th
                        id="cnpj"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        CNPJ
                      </th>
                      <th
                        id="empresa"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Empresa
                      </th>
                      <th
                        id="status"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Status
                      </th>
                      <th
                        id="plano"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Plano
                      </th>
                      <th
                        id="segmento"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Segmento
                      </th>
                      <th
                        id="produto"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        &emsp; Produto &emsp;
                      </th>
                      <th
                        id="fatura_avulsa"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Fatura Avulsa
                      </th>
                      <th
                        id="cancelamento"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Cancelamento
                      </th>
                      <th
                        id="mes"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Mês
                      </th>
                      <th
                        id="data_faturamento_emissao"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Data de Faturamento/Emissão
                      </th>
                      <th
                        id="total_fatura"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Total Fatura
                      </th>
                      <th
                        id="adicionais"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Adicionais
                      </th>
                      <th
                        id="desconto"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Desconto
                      </th>
                      <th
                        id="acrescimo"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Acréscimo
                      </th>
                      <th
                        id="total_cobrado"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Total cobrado
                      </th>
                      <th
                        id="plano_mensal"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Plano Mensal
                      </th>
                      <th
                        id="licencas"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Licenças
                      </th>
                      <th
                        id="contatos_receptivos"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contatos receptivos
                      </th>
                      <th
                        id="numeros"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Números
                      </th>
                      <th
                        id="ativos_unico"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Ativos - único
                      </th>
                      <th
                        id="ativos_campanha"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Ativos - campanha
                      </th>
                      <th
                        id="consultoria_mensal"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Consultoria Mensal
                      </th>
                      <th
                        id="licencas_valor_minimo"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Licenças (valor mínimo)
                      </th>
                      <th
                        id="ativos_unico_valor_minimo"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Ativos - único (valor mínimo)
                      </th>
                      <th
                        id="ativos_campanha_valor_minimo"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Ativos - campanha (valor mínimo)
                      </th>
                      <th
                        id="protocolos"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Protocolos
                      </th>
                      <th
                        id="auto_negociador"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Auto Negociador
                      </th>
                      <th
                        id="auto_negociador_valor_minimo"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Auto Negociador (valor mínimo)
                      </th>
                      <th
                        id="cross_sell_engajamento"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Cross Sell Engajamento
                      </th>
                      <th
                        id="setup_aquisicao"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Setup aquisição
                      </th>
                      <th
                        id="numero_extra"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Número extra
                      </th>
                      <th
                        id="consultoria"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Consultoria
                      </th>
                      <th
                        id="customizacao"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Customização
                      </th>
                      <th
                        id="suporte_24x7"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Suporte 24x7
                      </th>
                      <th
                        id="outros"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Outros
                      </th>
                      <th
                        id="atendimento"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Atendimento
                      </th>
                      <th
                        id="contato_agenda"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contato/Agenda
                      </th>
                      <th
                        id="cpfs_unico"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        CPFs - Único
                      </th>
                      <th
                        id="cancelamento_2"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Cancelamento
                      </th>
                      <th
                        id="ativos_sms"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Ativos - SMS
                      </th>
                      <th
                        id="contatos_envios_ativos"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contatos + Envios de Ativos
                      </th>
                      <th
                        id="ativos_unico_campanha"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Ativos único + Ativos de Campanha
                      </th>
                      <th
                        id="ativos_unico_campanha"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Relatório
                      </th>
                      <th
                        id="uam"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        UAM
                      </th>
                      <th
                        id="hsm"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        HSM
                      </th>
                      <th
                        id="hsm_ativos_unico"
                        class="text-center align-middle"
                        style="white-space: nowrap; min-width: 200px"
                      >
                        HSM - Ativos Único
                      </th>
                      <th
                        id="hsm_ativos_campanha"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        HSM - Ativos Campanha
                      </th>
                      <th
                        id="atendimento_protocolo"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Atendimento / Protocolo
                      </th>
                      <th
                        id="ativos_campanha_sms"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Ativos Campanha - SMS
                      </th>
                      <th
                        id="mensagens"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Mensagens
                      </th>
                      <th
                        id="sessao_autenticacao"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Sessão - Autenticação
                      </th>
                      <th
                        id="sessao_utilitario"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Sessão - Utilitário
                      </th>
                      <th
                        id="sessao_marketing"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Sessão - Marketing
                      </th>
                      <th
                        id="sessao_servicos"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Sessão - Serviços
                      </th>
                      <th
                        id="numeros_whatsapp_enterprise"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Números Whatsapp Enterprise
                      </th>
                      <th
                        id="numeros_whatsapp_enterprise"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Adicionais
                      </th>
                      <th
                        id="numeros_whatsapp_enterprise"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Projetos de Aquisição
                      </th>
                      <th
                        id="numeros_whatsapp_enterprise"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Setup Base
                      </th>
                      <th
                        id="numeros_whatsapp_enterprise"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Projetos Base
                      </th>
                      <th
                        id="numeros_whatsapp_enterprise"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Cancelamento
                      </th>
                      <th
                        id="numeros_whatsapp_enterprise"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Multas Contratuais
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-bind:class="{
                            inputTextFilter: !data || data.length == 0,
                          }"
                          v-model="filters.customer_id"
                          :disabled="disabledFilters"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-bind:class="{
                            inputTextFilter: !data || data.length == 0,
                          }"
                          v-model="filters.cnpj"
                          :disabled="disabledFilters"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-bind:class="{
                            inputTextFilter: !data || data.length == 0,
                          }"
                          v-model="filters.name"
                          :disabled="disabledFilters"
                        />
                      </td>
                      <td>
                        <SelectStatuses
                          :selected="filters.status"
                          @change="setFilter('status', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td>
                        <SelectPlanTypes
                          :selected="filters.plan_type_id"
                          @change="setFilter('plan_type_id', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td></td>
                      <td>
                        <SelectProducts
                          :selected="filters.product"
                          @change="setFilter('product', $event)"
                          class="form-control-sm"
                          :productsNotAppear="[2, 3, 4, 5, 6]"
                        />
                      </td>
                      <td>
                        <SelectYesNo
                          :selected="filters.detached"
                          @change="setFilter('detached', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr v-for="(invoice, id) in data.data" :key="id">
                      <td class="text-center align-middle">
                        {{ invoice.customer_id }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          invoice.customer
                            ? invoice.customer.documents.value
                            : null | cnpj | cpf
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.co_name }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ getStatus(invoice.status) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          invoice.plan_type
                            ? invoice.plan_type
                            : invoice.plan_description
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.segment }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.product.name }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.detached }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.cancellation ? 'Sim' : 'Não' }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.billing_month | date }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.billing_date_external | date }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.price_total | money }}
                      </td>
                      <td>
                        {{
                          calcAditionals(
                            invoice.price_total,
                            invoice.discount,
                            sumDetail(invoice.details, [7, 20, 22, 32])
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.discount | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.price_extra | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ (invoice.price_total - invoice.discount) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumDetail(
                            invoice.details,
                            [7, 20, 22, 32, 72, 73, 74, 97]
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [1]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [2]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [3]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [4]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [5]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [6]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [8]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [9]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [10]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [11]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [12]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [13]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [14, 26, 37]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [41, 42, 43]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [15]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [16]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [17]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [18]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [19, 21]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [23]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [24]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [25]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [27]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [28]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [29]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [56]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [69]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [30]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [31]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [33]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [34]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [35]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [36]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [55]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [54, 66]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [53, 65]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [52, 64]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [51, 63]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [44, 68]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [75, 76, 77, 101, 102, 103]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [78, 79, 80]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [81, 82, 83, 100]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [84, 85, 86]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [87, 88, 89]) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumDetail(invoice.details, [90, 91, 92]) | money }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um
                  total de {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else
                  >Nenhum item a ser exibido.</span
                >
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                    >
                      <a class="page-link paginate" @click="page = 1">
                        <i class="fal fa-angle-double-left"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page - 1"
                      >
                        <i class="fal fa-angle-left"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page - 2"
                        >{{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page - 1"
                        >{{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate">{{ data.current_page }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page + 1"
                        >{{ data.current_page + 1 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        disabled: data.current_page + 1 == data.last_page,
                      }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page + 2"
                        >{{ data.current_page + 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page + 1"
                      >
                        <i class="fal fa-angle-right"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.last_page"
                      >
                        <i class="fal fa-angle-double-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectProducts from '@/components/forms/SelectProducts';
import SelectStatuses from '@/components/forms/SelectInvoiceStatuses';
import SelectPlanTypes from '@/components/forms/SelectPlanTypes';
import SelectYesNo from '@/components/forms/SelectYesNo';
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import SelectContractStatus from '@/components/forms/SelectContractStatus';
import SelectCustomerGroups from '@/components/forms/SelectCustomerGroups';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'ReportInvoiceAnalytics',
  props: ['start', 'finish', 'createdAt'],
  components: {
    SelectProducts,
    SelectContractStatus,
    SelectStatuses,
    SelectPlanTypes,
    SelectYesNo,
    SelectCustomerGroups,
  },
  data() {
    return {
      disabledFilters: false,
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      sortType: localStorage.reportInvoicesAnalyticsSortType
        ? localStorage.reportInvoicesAnalyticsSortType
        : 'id',
      sortReverse: localStorage.reportInvoicesAnalyticsSortReverse
        ? JSON.parse(localStorage.reportInvoicesAnalyticsSortReverse)
        : false,
      amount: localStorage.reportInvoicesAnalyticsDataAmount
        ? localStorage.reportInvoicesAnalyticsDataAmount
        : 100,
      page: localStorage.reportInvoicesAnalyticsDataPage
        ? localStorage.reportInvoicesAnalyticsDataPage
        : 1,
      filters: {
        id: localStorage.reportInvoicesAnalyticsFilterId
          ? localStorage.reportInvoicesAnalyticsFilterId
          : '',
        customer_id: localStorage.reportInvoicesAnalyticsFilterCustomer
          ? localStorage.reportInvoicesAnalyticsFilterCustomer
          : '',
        name: localStorage.reportInvoicesAnalyticsFilterName
          ? localStorage.reportInvoicesAnalyticsFilterName
          : '',
        cnpj: localStorage.reportInvoicesAnalyticsFilterCnpj
          ? localStorage.reportInvoicesAnalyticsFilterCnpj
          : '',
        product: localStorage.reportInvoicesAnalyticsFilterProduct
          ? localStorage.reportInvoicesAnalyticsFilterProduct
          : '',
      },
      data: [],
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
  },
  methods: {
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    async download() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando relatório',
        reason: '',
      };

      const urlCount = `${baseApiUrl}/v1/report/invoice/analytics/count${this.convertFilters()}`;
      const total = await axios.get(urlCount);

      if (total.data <= 1000) {
        const url = `${baseApiUrl}/v1/report/invoice/analytics/download${this.convertFilters()}`;
        axios
          .get(url)
          .then((res) => {
            const arrData = res.data;
            let csvContent = 'data:text/csv;charset=utf-8,';
            let array = this.mountArray(arrData);
            csvContent += array.join('\n').replace(/(^\[)|(\]$)/gm, '');

            const data = encodeURI(csvContent);

            const link = document.createElement('a');
            link.setAttribute('href', data);

            let fileName = `relatorio_analitico_faturamento`;

            this.clearAlert();
            if (this.start) {
              fileName += `_${this.start}`;
            }
            fileName = `${fileName}.csv`;
            link.setAttribute('download', fileName);

            link.click();
          })
          .catch((error) => {
            this.logMessageFailed(error.response);
          });
      } else {
        let arrData = [];
        let pages = Math.ceil(total.data / 1000);
        for (let index = 1; index <= pages; index++) {
          let data = await this.getDataByPages(index);
          arrData = arrData.concat(data);
        }
        let csvContent = 'data:text/csv;charset=utf-8,';
        let array = this.mountArray(arrData);
        csvContent += array.join('\n').replace(/(^\[)|(\]$)/gm, '');

        const data = encodeURI(csvContent);

        const link = document.createElement('a');
        link.setAttribute('href', data);

        let fileName = `relatorio_analitico_faturamento`;

        this.clearAlert();
        if (this.start) {
          fileName += `_${this.start}`;
        }
        fileName = `${fileName}.csv`;
        link.setAttribute('download', fileName);

        link.click();
      }
    },

    getDataByPages(index) {
      const url = `${baseApiUrl}/v1/report/invoice/analytics/page/${index}/download${this.convertFilters()}`;
      return axios
        .get(url)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.callData();
    },
    setFilter(filterToChange, id) {
      this.disabledFilters = false;
      if (filterToChange == 'groupId' && id) {
        this.disabledFilters = true;
      }
      this.filters[filterToChange] = id;
    },
    clearFilters() {
      this.filters.customer_id = '';
      this.filters.name = '';
      this.filters.cnpj = '';
      this.status = '';
      this.filters.product = '';
      this.filters.sortType = 'customer_id';
      this.filters.sortReverse = false;
      this.filters.plan_type_id = '';
      this.filters.detached = '';
      this.filters.groupId = '';
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('reportInvoicesAnalyticsFilterId', this.filters.id);
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterCustomer',
        this.filters.customer_id
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterName',
        this.filters.name
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterCnpj',
        this.filters.cnpj
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterStatus',
        this.filters.status
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterProduct',
        this.filters.product
      );
      localStorage.setItem('reportInvoicesAnalyticsDataAmount', this.amount);
      localStorage.setItem('reportInvoicesAnalyticsDataPage', this.page);
      localStorage.setItem('reportInvoicesAnalyticsSortType', this.sortType);
      localStorage.setItem(
        'reportInvoicesAnalyticsSortReverse',
        this.sortReverse
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterId',
        this.filters.plan_type_id
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterDetached',
        this.filters.detached
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterGroupId',
        this.filters.groupId
      );
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&customer=${this.filters.customer_id ? this.filters.customer_id : ''}
        &name=${this.filters.name ? this.filters.name : ''}&cnpj=${
        this.filters.cnpj ? this.filters.cnpj : ''
      }&status=${this.filters.status ? this.filters.status : ''}&product=${
        this.filters.product ? this.filters.product : ''
      }&planType=${
        this.filters.plan_type_id ? this.filters.plan_type_id : ''
      }&amount=${this.amount}&detached=${
        this.filters.detached ? this.filters.detached : ''
      }&sortType=${this.sortType}&sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}
      &start=${this.start}
      &end=${this.finish ? this.finish : this.start}
      &createdAt=${this.createdAt}
      &groupId=${this.filters.groupId}`;

      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      this.data.current_page = 0;
      this.setStorageFilters();
      this.getDatas();
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/report/invoice/analytics${this.convertFilters()}`;
      axios(url)
        .then((res) => {
          this.data = res.data;
          this.$emit('updateLoading');
          if (res.data.current_page > res.data.last_page) {
            this.page = 1;
          }
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    sumDetail(details, ids) {
      return details
        .filter((item) => ids.includes(item.detail_id))
        .map((item) => parseFloat(item.total))
        .reduce((prev, curr) => prev + curr, 0);
    },
    mountArray(arrayInvoices) {
      let linesArray = [];
      linesArray[0] =
        'ID Cliente;CNPJ;Empresa;Status;Plano;Segmento;Produto;Fatura Avulsa;Cancelamento;Mês;Data de Faturamento/Emissão;Total Fatura;Adicionais;Desconto;Acréscimo;Total Cobrado;Plano Mensal;' +
        'Licenças;Contatos receptivos;Números;Ativos - único;Ativos - campanha;Consultoria mensal;' +
        'Licenças (valor mínimo);Ativos - único (valor mínimo);Ativos - campanha (valor mínimo);Protocolos;Auto Negociador;Auto Negociador (valor mínimo);' +
        'Cross Sell Engajamento;Setup aquisição;Número extra;' +
        'Consultoria;Customização;Suporte 24x7;Outros;Atendimento;Contato/Agenda;CPFs - Único;Cancelamento;Ativos - SMS;Contatos + Envios de Ativos;' +
        'Ativos Único + Ativos Campanha;Relatório;UAM;HSM;HSM - Ativos Único;HSM - Ativos Campanha;' +
        'Atendimento / Protocolo;Ativos Campanha - SMS;' +
        'Mensagens;Sessão - Autenticação;Sessão - Utilitário;Sessão - Marketing;Sessão - Serviços;Números Whatsapp Enterprise;Adicionais;' +
        'Projetos de Aquisição;Setup Base;Projetos Base;Cancelamento;Multas Contratuais';

      arrayInvoices.forEach((item) => {
        const line =
          item.customer_id +
          ';' +
          item.customer.documents.value +
          ';' +
          (item.co_name || '') +
          ';' +
          this.getStatus(item.status) +
          ';' +
          (item.plan_type
            ? item.plan_type
            : item.plan_description
            ? item.plan_description
            : '') +
          ';' +
          item.segment +
          ';' +
          item.product.name +
          ';' +
          item.detached +
          ';' +
          (item.cancellation ? 'Sim' : 'Não') +
          ';' +
          item.billing_month +
          ';' +
          (item.billing_date_external ? item.billing_date_external : '') +
          ';' +
          this.formatCurrency(item.price_total) +
          ';' +
          this.formatCurrency(
            this.calcAditionals(
              item.price_total,
              item.discount,
              this.sumDetail(item.details, [7, 20, 22, 32])
            )
          ) +
          ';' +
          this.formatCurrency(item.discount) +
          ';' +
          this.formatCurrency(item.price_extra) +
          ';' +
          this.formatCurrency(item.price_total - item.discount) +
          ';' +
          this.formatCurrency(
            this.sumDetail(item.details, [7, 20, 22, 32, 72, 73, 74, 97])
          ) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [1])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [2])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [3])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [4])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [5])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [6])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [8])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [9])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [10])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [11])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [12])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [13])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [14, 26, 37])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [41, 42, 43])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [15])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [16])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [17])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [18])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [19, 21])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [23])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [24])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [25])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [27])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [28])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [29])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [56])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [69])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [30])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [31])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [33])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [34])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [35])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [36])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [55])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [54, 66])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [53, 65])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [52, 64])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [51, 63])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [44, 68])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [75, 76, 77, 101, 102, 103])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [78, 79, 80])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [81, 82, 83, 100])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [84, 85, 86])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [87, 88, 89])) +
          ';' +
          this.formatCurrency(this.sumDetail(item.details, [90, 91, 92])) +
          ';';
        linesArray.push(line);
      });
      return linesArray;
    },
    formatCurrency(value) {
      if (!value) {
        value = 0;
      }
      return value.toLocaleString();
    },
    getStatus(status) {
      switch (status) {
        case 0:
          return 'Não Conferida';
        case 1:
          return 'Conferida';
        case 2:
          return 'Venda Gerada';
        case 3:
          return 'Cancelada';
        case 4:
          return 'Paga';
        case 5:
          return 'Parcialmente Paga';
        case 6:
          return 'Expirado';
        default:
          break;
      }
    },
    calcAditionals(price_total, discount, plan) {
      let total = 0;
      total = price_total - discount;
      return total > plan ? total - plan : 0;
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
    this.clearAlert();
  },
};
</script>

<style scoped>
.inputNumberFilter {
  width: 100px;
}

.inputTextFilter {
  width: 200px;
}
</style>
